<p-messages [(value)]="msgs"></p-messages>
<div class="grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="p-fluid p-formgrid p-grid surface-section px-4 py-8 md:px-6 lg:px-8" *ngIf="!this.assistant.complete">
            <div class="text-700 text-center">
                <div class="text-blue-600 font-bold mb-3"><i class="pi pi-heart"></i>&nbsp;¡ Hola {{currentUser.firstname }} ! </div>
                <div class="text-900 font-bold text-7xl mb-3">Bienvenido a {{appConfig.app.name}}</div>
                <div class="text-700 text-2xl mb-5">Aún hay que completar algunos detalles y luego a facturar muy fácil.</div>
                <p-listbox  [options]="assistant.items"  optionLabel="name" optionDisabled="complete || true"
                            [(ngModel)]="itemAssistant"
                            [ngModelOptions]="{standalone: true}"
                            [multiple]="false" [checkbox]="false" 
                            [metaKeySelection]="false"
                            (onClick)="irAAssistentOpcion($event)"
                            (onDblClick)="irAAssistentOpcion($event)"
                            emptyMessage="{{appConfig.ux.emptyMsg}}"
                            [listStyle]="{'max-height':'500px'}"
                            class="p-listbox-assistant">
                    <ng-template let-item pTemplate="item">
                        <div class="w-full text-left"
                             [pTooltip]="'Clic para completar '+ item.name.toLowerCase()" tooltipPosition="bottom"
                             style="display: contents;">
                            <i class="{{item.complete ? 'pi pi-check-circle text-green-600 text-6xl' : 'pi pi-arrow-right text-pink-600 text-6xl'}}"></i>
                            <span class="ml-1">
                                {{item.name}}
                                <strong>{{item.description}}</strong>
                            </span>
                        </div>
                    </ng-template>
                </p-listbox>
                <button 
                    pButton
                    pRipple
                    type="button"
                    label="Nueva factura"
                    size="xlarge"
                    icon="pi pi-send"
                    class="font-bold px-5 py-3 p-button-raised p-button-rounded white-space-nowrap p-button-lg"
                    (click)="fazilService.irAFactura()" 
                    [disabled]="!assistant.complete">
                </button>
            </div>
        </div>
        <div class="card" *ngIf="this.assistant.complete">
            <p-toolbar styleClass="mb-2 bg-gray-200">
                <ng-template pTemplate="left">
                    <button pButton pRipple
                            type="button"
                            label="Nueva Nota de Crédito" 
                            icon="pi pi-plus"
                            class="p-button-danger p-button-lg"
                            (click)="nuevaFactura($event);"><!--[disabled]="!puedeEjecutar('crear')"-->
                    </button>
                    <button pButton pRipple
                            type="button" label="Descargar informes"
                            pTooltip="{{ appConfig.ux.actions.download }} {{ 'Excel' }}" tooltipPosition="bottom" 
                            icon="pi pi-file-excel" class="ml-1 p-button-raised"
                            (click)="generateItemsToPDFByReporte($event);"
                            [disabled]="(!facturas || facturas.lenght < 1)">
                    </button>
                </ng-template>
                <ng-template pTemplate="right">
                    <p-button *ngFor="let item of buttonsFacturasInvalidas let i = index" 
                              [label]="item.text" [badge]="item.data" [styleClass]="item.cssClass"
                              (click)="viewFacturasPorStatus($event, item.text, item.status, item.data); opiv.hide($event)">
                    </p-button>
                    <button pButton pRipple type="button" 
                            pTooltip="{{appConfig.ux.actions.home}}" tooltipPosition="bottom" 
                            icon="pi pi-refresh" class="p-button-rounded p-button-info m-1"
                            (click)="cargarDataInit();">
                    </button>
                </ng-template>
            </p-toolbar>
            <p-table #dt id="facturas"
                     [value]="facturas" [columns]="selectedColumns" dataKey="id"
                     [rowHover]="true" [rows]="10" [paginator]="true"
                     [scrollable]="false" [responsive]='true'
                     [filterDelay]="0" [globalFilterFields]="['secuencial', 'claveAcceso', 'customerFullName', 'resumen']"
                     sortMode="multiple" [multiSortMeta]="multiSortMeta"
                     [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <span class="p-input-icon-left ml-1 w-full mr-2">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                   placeholder="Buscar.."
                                   class="w-full"/>
                        </span>
                        <p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
                                       selectedItemsLabel="{0} columnas visibles" [style]="{minWidth: '200px'}" placeholder="Ver más/menos información"></p-multiSelect>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 1rem !important;">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [hidden]="!col.visible" [ngClass]="col.class">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </div>
                    </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td>
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td>
                    <td pResizableColumn *ngFor="let col of columns" [hidden]="!col.visible" [ngClass]="col.class">
                        <span *ngIf="col.field != 'isPayment'"> {{col.field == 'importeTotal' ? ('$'+rowData[col.field].toFixed(2)) :  rowData[col.field]}}</span>
                    </td>
                    <td>
                    <p-splitButton  icon="pi pi-print" 
                                    label="Imprimir"
                                    (onClick)="imprimirFactura(rowData)" 
                                    [model]="cmds(rowData)"
                                    *ngIf="status=='APPLIED'&& status !='INVALID'"></p-splitButton>
                    
                    <p-splitButton  icon="pi pi-key" 
                                    label="Ver error"
                                    (onClick)="irAVerError(rowData)" 
                                    [model]="cmds(rowData)"
                                    *ngIf="status == 'INVALID'"></p-splitButton>
                    </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td>{{appConfig.ux.emptyMsg}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <button pButton type="button" 
                            pTooltip="{{appConfig.ux.actions.refresh}}" tooltipPosition="bottom" 
                            icon="pi pi-refresh" class="p-button-rounded p-button-text"
                            (click)="dt.reset();">
                    </button>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<!---Diálogo de acciones--->
<p-overlayPanel #op
                [style]="{ width: '15vw' }"
                [showCloseIcon]="false">
    <ng-template pTemplate>
        <div class="p-fluid p-formgrid p-grid">
            <button *ngFor="let item of buttonsActions let i = index" 
                    pButton type="button" 
                    [label]="item.text"
                    [icon]="item.icon"
                    [class]="item.cssClass"
                    (click)="ejecutarAccion($event, item.action, item.data); op.hide($event)"
                    [disabled]="item.disabled"
                    class="p-text-over-wrap">
            </button>
        </div>
    </ng-template>
</p-overlayPanel>
<!---Diálogo de facturas inválidas--->
<p-overlayPanel #opiv
                [style]="{ width: '20vw' }"
                [showCloseIcon]="false">
    <ng-template pTemplate>
        <div class="p-fluid p-formgrid p-grid">
            <button *ngFor="let item of buttonsFacturasInvalidas let i = index" 
                    pButton type="button" 
                    [label]="item.text"
                    [class]="item.cssClass"
                    (click)="viewFacturasPorStatus($event, item.status, item.data); opiv.hide($event)"
                    [disabled]="item.disabled"
                    class="p-text-over-wrap">
            </button>
        </div>
    </ng-template>
</p-overlayPanel>
<!---Diálogo de visualización de facturas inválidas--->
<p-dialog [(visible)]="mostrarPopupFacturasInvalidas" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '55vw', '640px': '80vw'}" [style]="{width: '55vw'}"
          (onHide)="mostrarPopupFacturasInvalidas=false;">
    <ng-template pTemplate="header">
        <h4>              
            {{tituloListadoPorStatus}}
        </h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-table #dtst [value]="facturasPorStatus" [columns]="colsPorStatus" dataKey="id"
                 selectionMode="multiple" [(selection)]="facturasPorStatusSeleccionados"
                 [rowHover]="true" [rows]="10" [paginator]="true"
                 [scrollable]="false" [responsive]='true'
                 [filterDelay]="0" [globalFilterFields]="['secuencial','customerFullName','resumen']"
                 sortMode="multiple" [multiSortMeta]="multiSortMetaPorStatus"
                 [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                 styleClass="p-datatable-striped p-datatable-sm">
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-start table-header">
                    </div>
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-end table-header">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dtst.filterGlobal($event.target.value, 'contains')"
                                   placeholder="Buscar.."/>
                        </span>
                        <p-button id="notification-button" 
                                  pTooltip="Ver totales" tooltipPosition="bottom" 
                                  styleClass="p-button-text p-button-sm"
                                  (click)="verTotalesFacturas($event, 'status')">
                            <ng-template pTemplate="content">
                                <img alt="bug" src="assets/layout/icons/dollar.png" style="width: 2rem" />
                                <span *ngIf="!enabledTotalsPorStatus" id="notification-note">/</span>
                            </ng-template>
                        </p-button>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th style="width: 3rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [hidden]="!col.visible" [ngClass]="col.class">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </div>
                </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td style="width: 3rem">
                <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                </td>
                <td *ngFor="let col of columns" [hidden]="!col.visible" [ngClass]="col.class">
                    <span *ngIf="col.field != 'isPayment'"> {{col.field == 'importeTotal' ? ('$'+rowData[col.field].toFixed(2)) :  rowData[col.field]}}</span>
                </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td>{{appConfig.ux.emptyMsg}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <button pButton type="button" 
                        pTooltip="{{appConfig.ux.actions.refresh}}" tooltipPosition="bottom" 
                        icon="pi pi-refresh" class="p-button-rounded p-button-text"
                        (click)="dtst.reset();">
                </button>
            </ng-template>
        </p-table>
    </ng-template>
    <ng-template pTemplate="footer">
    </ng-template>
</p-dialog>
<!--Ventana de mostrar plan-->
<p-dialog [(visible)]="mostrarPlanPopup" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '45vw', '640px': '65vw' }"
          [style]="{ width: '45vw' }"
          (onHide)="mostrarPlanPopup=false;"
          [resizable]="false">
    <ng-template pTemplate="header">
        <span></span>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="grid relative">
            <div class="col-12 lg:col-6 text-center align-self-center">
                <img src="assets/layout/images/login/logo-login.png" alt="{{appConfig.app.name}}" class="w-10rem sm:w-15rem lg:w-20rem">
            </div>
            <div class="col-12 lg:col-6 lg:pl-5 align-self-center">
                <div class="flex align-items-center justify-content-between mb-3">
                    <span class="text-xl font-medium text-900">{{planOrganizacion.planName}}</span>
                </div>
                <div class="flex align-items-center justify-content-between mb-3">
                    <div class="text-xl text-900 font-bold">$ {{planOrganizacion.precio}}</div>
                </div>
                <p class="p-0 mt-0 mb-3 line-height-3 text-700">{{planOrganizacion.description}}.</p>
                <p class="p-0 mt-0 mb-3 line-height-3 text-700 text-yellow-900">Desde <strong>{{planOrganizacion.fechaInicio | date: 'yyyy/MM/dd'}}</strong> hasta <strong>{{planOrganizacion.fechaFin | date: 'yyyy/MM/dd'}}</strong>.</p>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="border-top-1 surface-border pt-3 flex align-items-center justify-content-center">
            <button pButton pRipple
                    type="button" 
                    label="OK"
                    icon="pi pi-check" class="w-full"
                    (click)="mostrarPlanPopup = false">
            </button>
        </div>
    </ng-template>
</p-dialog>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd 
                 header="{{appConfig.ux.confirmMsg}}" 
                 icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmFalse}}"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmTrue}}"
                icon="pi pi-check" class="ml-1"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>
<!--Ventana de espera de procesamiento-->
<p-dialog [(visible)]="procesando" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
          [style]="{ width: '90vw' }"
          (onHide)="procesando=false;">
    <ng-template pTemplate="header">
        <h4>{{appConfig.ux.loadingMsg}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-progressBar mode="indeterminate"></p-progressBar> 
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="uppercase">{{appConfig.app.name}}</span>
    </ng-template>
</p-dialog>
<!--Ventana de resultData-->
<p-dialog [(visible)]="mostrarResultData" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '25vw', '640px': '35vw' }" 
          [style]="{ width: '25vw' }"
          (onHide)="mostrarResultData=false;">
    <ng-template pTemplate="header">
        <h4>{{resultData['header']}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="inline-flex">
            <i [class]="(resultData['type'] && resultData['type'].includes('success')) ? 'pi pi-check-square text-6xl' : 'pi pi-exclamation-triangle text-6xl'"></i>
            <span class="ml-1 align-self-center">{{resultData['body']}}</span>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex align-items-center justify-content-center">
            <button *ngFor="let item of resultDataButtons let i = index" 
                    pButton pRipple
                    type="button" 
                    [label]="item.text"
                    [icon]="item.icon"
                    [class]="item.cssClass"
                    (click)="ejecutarAccionResult($event, item.action, null)"
                    [disabled]="item.disabled">
            </button>
        </div>
    </ng-template>
</p-dialog>
<!--Ventana de previsualización de reportes-->
<p-dialog header="RIDE" [(visible)]="mostrarVisualidorReporteRIDE" [modal]="true" 
          styleClass="dialogCustom" [contentStyle]="{minHeight: '200px'}" 
          [draggable]="false" [resizable]="false">
    <div class="p-grid">
        <div class="col-12 p-md-8 p-lg-9" style="align-self: center; padding-bottom: 0rem">
            <p-message severity="error" text="No fue posible obtener el RIDE, cierre la ventana e intente nuevamente." 
                       *ngIf="!reporteGenerado">
            </p-message>
        </div>
        <p-toolbar>
            <div class="p-toolbar-group-left">
                <span class="p-text-uppercase p-text-bold" style="font-size: 1.5rem">{{ reporteFactura.secuencial }}</span>
                <span class="p-text-uppercase p-text-over-wrap" style="font-size: 1rem"> [{{ reporteFactura.claveAcceso }}]</span>
            </div>

            <div class="p-toolbar-group-right">
                <button pButton pRipple type="button" icon="pi pi-download" label="Descargar el RIDE" class="p-button-raised p-button-danger p-mr-2 p-mb-2"
                        (click)="descargarReporte()"
                        [disabled]="!reporteGenerado"></button>
            </div>
        </p-toolbar>

        <div class="col-4 p-md-12 p-lg-12" style="align-self: center; padding-bottom: 0rem">
            <pdf-viewer
                [src]="reporteURL"
                [rotation]="0"
                [original-size]="true"
                [show-all]="true"
                [fit-to-page]="true"
                [zoom]="1"
                [zoom-scale]="'page-width'"
                [stick-to-page]="true"
                [render-text]="true"
                [external-link-target]="'blank'"
                [autoresize]="true"
                [show-borders]="true"
                style="min-width:800px; height: 600px"
                ></pdf-viewer>
        </div>
    </div>
</p-dialog>
<!-- Diálogo de selección de reporte-->
<p-dialog header="Reportes Disponibles" [(visible)]="mostrarSelectorReporte" 
          [modal]="true" showEffect="fade" [style]="{width: '500px'}"
          [transitionOptions]="'0ms'" (onHide)="mostrarSelectorReporte=false;">
    <p-listbox [options]="catalogoReportes"
               [metaKeySelection]="false"
               [(ngModel)]="reporte" optionLabel="name"
               [ngModelOptions]="{standalone: true}"
               (onClick)="generarReporte($event)"
               (onDblClick)="generarReporte($event)"
               (onChange)="generarReporte($event)"
               emptyMessage="Aún sin definir reportes..."
               [filter]="true" emptyFilterMessage="No se encontraron resultados."
               [listStyle]="{'max-height':'250px'}">
    </p-listbox>
</p-dialog>
<!--Ventana de previsualización de reportes-->
<p-dialog header="Vista previa de reporte" [(visible)]="mostrarVisualidorReporte" [modal]="true" 
          styleClass="dialogCustom" [contentStyle]="{minHeight: '100px'}" 
          [draggable]="false" [resizable]="false">
    <div class="p-grid">
        <div class="p-col-12 p-md-12 p-lg-12" style="align-self: center; padding-bottom: 0rem">
            <span class="p-text-uppercase p-text-bold" style="font-size: 1.5rem">
                {{reporte.name}}
            </span>
        </div>
        <div class="p-col-9" style="align-self: center; padding-bottom: 0rem">
            <p-message severity="error" text="No fue posible obtener el reporte, cierre la ventana e intente nuevamente." 
                       *ngIf="!reporteGenerado">
            </p-message>
        </div>
        <div class="p-col-3" style="align-self: center; padding-bottom: 0rem">
            <div class="p-grid p-nogutter p-justify-end">
                <button pButton pRipple type="button" icon="pi pi-download" label="Descargar el reporte" class="p-button-raised p-button-danger p-mr-2 p-mb-2"
                        (click)="descargarReporte()"
                        [disabled]="!reporteGenerado"></button>
            </div>
        </div>
        <div class="p-col-12 p-md-12 p-lg-12" style="align-self: center; padding-bottom: 0rem">
            <pdf-viewer
                [src]="reporteURL"
                [rotation]="0"
                [original-size]="false"
                [show-all]="true"
                [fit-to-page]="true"
                [zoom]="1"
                [zoom-scale]="'page-width'"
                [stick-to-page]="false"
                [render-text]="true"
                [external-link-target]="'blank'"
                [autoresize]="true"
                [show-borders]="false"
                style="min-width: 1024px;"
                ></pdf-viewer>
        </div>
    </div>
</p-dialog>





<!--Ventana de resultData-->
<p-dialog [(visible)]="mostrarMensajesResultData" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '25vw', '640px': '35vw' }" 
          [style]="{ width: '25vw' }"
          (onHide)="mostrarMensajesResultData=false;">
    <ng-template pTemplate="header">
        <h4>{{resultsData['header']}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-messages severity="{{resultsData['type']}}">
            <ng-template pTemplate>
                <div class="ml-2">{{resultsData['body']}}</div>
            </ng-template>
        </p-messages>

        <p-panel header="Detalle de errores" [toggleable]="true" [collapsed]="false" *ngIf="resultsData['subErrors'] && resultsData['subErrors'].length > 0">
            <p-messages severity="info" *ngFor="let subError of resultsData['subErrors']">
                <ng-template pTemplate>
                    <div class="ml-2">{{subError.field}} | {{subError.rejectedValue}} | {{subError.message}}</div>
                </ng-template>
            </p-messages>
        </p-panel>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex align-items-center justify-content-center">
            <button *ngFor="let item of resultDataButtons let i = index" 
                    pButton pRipple
                    type="button" 
                    [label]="item.text"
                    [icon]="item.icon"
                    [class]="item.cssClass"
                    (click)="mostrarMensajesResultData=false"
                    [disabled]="item.disabled">
            </button>
        </div>
    </ng-template>
</p-dialog>


<!-- Diálogo de destinatarios-->
<p-dialog header="Reenviar notificación de nota de cŕedito" [(visible)]="mostrarDestinatariosNotificacion" 
          [modal]="true" showEffect="fade" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw', height: '600px'}"
          [transitionOptions]="'0ms'" (onHide)="mostrarDestinatariosNotificacion=false;">
    <form #notificacionForm="ngForm" 
          (ngSubmit)="enviarNotificacion();"
          [ngClass]="{'disabledForm': facturaEnNotificacion && facturaEnNotificacion.internalStatus && (facturaEnNotificacion.internalStatus == 'POSTED')}"><!-- facturaEditorForm.reset();-->
        <div class="p-fluid p-formgrid grid">
            <p-messages [(value)]="msgs"></p-messages>
            <div class="p-field col-12">
                <label for="destinatarios">Reenviar a: </label>
                <p-chips [(ngModel)]="destinatarios" [separator]="separatorExp"
                         placeholder="(Presione enter, espacio, escape o coma, para separar destinatarios)" 
                         showClear='true'
                         addOnBlur='true'
                         [ngModelOptions]="{standalone: true}"
                         (onAdd)='agregarDestinatario($event)'></p-chips>
            </div>
            <div class="p-field col-12">
                <label for="mensaje">Mensaje: </label>
                <textarea #mensajeNotificacionCtrl="ngModel" id="mensajeNotificacion" name="mensajeNotificacion" type="text"
                          [(ngModel)]="mensajeNotificacion" 
                          [ngModelOptions]="{standalone: true}"
                          [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                          [rows]="3"
                          placeholder="Mensaje..."
                          pInputTextarea></textarea>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                           *ngIf="notificacionForm.controls['mensajeNotificacionCtrl'] 
                           && !notificacionForm.controls['mensajeNotificacionCtrl'].valid 
                           && (notificacionForm.controls['mensajeNotificacionCtrl'].dirty 
                           || notificacionForm.controls['mensajeNotificacionCtrl'].touched)">
                </p-message>
            </div>
        </div>
         <p-footer>
            <div class="flex align-items-center justify-content-end">
                <button
                    pButton pRipple
                    type="button"
                    label="{{ appConfig.ux.actions.cancel }}"
                    icon="pi pi-times" class="p-button-secondary"
                    (click)="mostrarDestinatariosNotificacion = false">
                </button>
                <button
                    pButton pRipple
                    type="submit"
                    label="{{ appConfig.ux.actions.send }}"
                    icon="pi pi-check" class="ml-1"
                    [disabled]="(!notificacionForm.valid)">
                </button>
            </div>
        </p-footer>
    </form>

</p-dialog>
<!-- //Diálogo de destintarios -->